import getTextDirection from 'wix-rich-content-common/libs/getTextDirection';

export const isTextDirectionRTL = (text) => getTextDirection(text) === 'rtl';
